import moment from 'moment'
import store from '@/store'

export default {
  getTimeStamp() {
    return parseInt(moment().utc().format('x'), 10)
  },
  getcurTimeStamp() {
    return parseInt(moment().utc().format('x'), 10) - store.state.offsetTime
  },
}
